/**
 * Whether a tab owns the path on show, decided the way NavLink decides it, so
 * the bar's sliding capsule and the tab's own colour never disagree: Home only
 * on `/` itself, every other tab on its own path and on anything below it
 * (`/trade/terminal` still belongs to Trade). Case is ignored, as the router
 * ignores it.
 */
export function tabOwnsPath(tab: string, pathname: string): boolean {
  const path = pathname.toLowerCase()
  if (tab === '/') return path === '/'
  return path === tab || path.startsWith(`${tab}/`)
}
